import { render, staticRenderFns } from "./InstallationTab.vue?vue&type=template&id=33bb5ec9&scoped=true&"
import script from "./InstallationTab.vue?vue&type=script&lang=js&"
export * from "./InstallationTab.vue?vue&type=script&lang=js&"
import style0 from "./InstallationTab.vue?vue&type=style&index=0&id=33bb5ec9&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bb5ec9",
  null
  
)

export default component.exports